document.getElementById("all").addEventListener("click", () => {
    filterCards("all");
});
document.getElementById("announcement").addEventListener("click", () => {
    filterCards("announcement");
});
document.getElementById("upsell").addEventListener("click", () => {
    filterCards("upsell");
});
document.getElementById("email").addEventListener("click", () => {
    filterCards("email");
});

function filterCards(filter) {
    // Remove active class from all buttons
    document.querySelectorAll('.filter-btn').forEach(btn => {
        btn.classList.remove('active');
    });
    
    // Add active class to clicked button
    document.getElementById(filter).classList.add('active');
    
    const cards = document.querySelectorAll(".demo-card");
    cards.forEach(card => {
        if (filter === "all" || card.id === filter) {
            card.style.display = "block";
        } else {
            card.style.display = "none";
        }
    });
}

// Default filter to show all cards on page load
filterCards("all");
